const zhHK = {
  100000001:'關鍵信息',
  100000002:'幣種簡稱',
  100000003:'副本創建者',
  100000004:'副本建立時間',
  100000005:'基礎資訊',
  100000006:'所屬公鏈/協議',
  100000007:'智能合約地址',
  100000008:'發行時間',
  100000009:'發行總量',
  100000010:'流通總量',
  100000011:'市值',
  100000012:'簡介',
  100000013:'社媒資訊',
  100000014:'官網',
  100000015:'白皮書',
  100000016:'區塊鏈瀏覽器',
  100000017:'專案評分',
  100000018:'排名',
  100000019:'前',
  100000020:'代碼安全',
  100000021:'項目經營',
  100000022:'價格和流動性',
  100000023:'團隊治理',
  100000024:'項目成熟度',
  100000025:'社區和社媒',
  100000026:'更新時間',
  100000027:'安全評分',
  100000028:'合約安全評分',
  100000029:'風險項目統計',
  100000030:'合約代碼的明細',
  100000031:'購買稅',
  100000032:'賣出稅',
  100000033:'是否是蜜罐',
  100000034:'是否可再次 Mint',
  100000035:'是否有黑名单',
  100000036:'是否有白名单',
  100000037:'是否反鯨魚',
  100000038:'是否可更改稅率',
  100000039:'是否開源',
  100000040:'是否有隱藏的持有者',
  100000041:'是否可自毀',
  100000042:'是否是代理合约',
  100000043:'是否可以更改餘額',
  100000044:'是否可執行外部調用',
  100000045:'是否可重新獲取所有權',
  100000046:'是否有交易冷靜期',
  100000047:'是否可暫停轉賬',
  100000048:'所有權未放棄  ',
  100000049:'是否是可調整的反鯨魚  ',
  100000050:'小數位數過多  ',
  100000051:'公開的 Mint 和 Burn 方法  ',
  100000052:'燃燒代幣是否會更新總量  ',
  100000053:'燃燒代幣是否會更新餘額  ',
  100000054:'自轉帳是否會增加餘額  ',
  100000055:'轉出大於餘額的代幣是否會失效',
  100000056:'餘額在轉帳中未更新  ',
  100000057:'是否會消耗接收方餘額  ',
  100000058:'調用TransferFrom超過餘額時是否會失敗',
  100000059:'BurnFrom方法是否會更新總量',
  100000060:'檢測代幣的購買稅。5%以上被認為是高稅率',
  100000061:'檢測代幣的賣出稅。5%以上被認為是高稅率',
  100000062:'檢測代幣是否是蜜罐騙局',
  100000063:'檢查是否可以鑄造更多代幣',
  100000064:'檢查代幣是否有可以限制用戶交換或轉移代幣的黑名單',
  100000065:'檢查代幣是否具有允許地址繞過任何限制的白名單',
  100000066:'檢查代幣是否有反鯨魚機制',
  100000067:'檢查代幣是否有稅收，並且稅收可以由特權角色修改',
  100000068:'檢查代幣是否已在區塊鏈瀏覽器上驗證',
  100000069:'檢查代幣是否有可以操縱合約的隱藏所有者，即使所有權似乎已被放棄',
  100000070:'檢查代幣是否可以自毀',
  100000071:'檢查代幣是否是將函數調用委託給實現合約的代理合約',
  100000072:'檢查代幣餘額是否可以由特權角色修改',
  100000073:'檢查代幣是否調用外部合約',
  100000074:'檢查代幣是否有後門以重新獲得所有權',
  100000075:'檢查代幣是否有轉賬冷卻機制',
  100000076:'檢查特權角色是否可以暫停代幣交易',
  100000077:'檢查所有者權限是否已放棄',
  100000078:'檢查代幣的反鯨魚機制是否可以由特權角色修改',
  100000079:'檢查decimals()函數的返回值是否大於或等於5',
  100000080:'檢查隨機用戶調用mint()和burn()函數是否會回退',
  100000081:'檢查調用burn()函數是否會正確更新totalSupply',
  100000082:"檢查調用burnFrom()函數是否會正確更新津貼",
  100000083:'檢查與交易發起人相同的收件人調用transfer()函數是否會增加發起人的餘額',
  100000084:'檢查調用金額超過餘額的transfer()函數是否會失敗',
  100000085:"調用transferFrom()函數後檢查消費者的餘額是否有相應的更新",
  100000086:"檢查調用transferFrom()函數是否會使用消費者餘額",
  100000087:"检查调用 transferFrom() 后，允许额度是否正确更新，或者如果金额无效，交易是否会被回滚。",
  100000088:"检查调用 burnFrom() 函数是否会正确更新总量",
  100000089:'檢查是否存在造幣權',
  100000090:'檢查是否存在凍結權',
  100000091:'檢查元數據是否可以更改',
  100000092:'致命',
  100000093:'严重',
  100000094:'中度',
  100000095:'轻度',
  100000096:'仅需知',
  100000097:' mint權限是否已放棄',
  100000098:' 凍結權限是否已放棄',
  100000099:' 是否可以更改代幣的元數據',

  100000100:'您的年度報告正在生成中…',
  100000101:'歡迎來到',
  100000102:'您的2024年回顧',
  100000103:'我是你的私人嚮導',
  100000104:'帶你一起回顧2024年走過的足跡',
  100000105:'開啟報告',
  100000106:'{num}天前，命運的齒輪開始轉動 ',
  100000107:'{userName} 我們的故事從這裡開始',
  100000108:'為了共同的夢想，我們一路奔跑',
  100000109:'投資盈利明星',
  100000110:'年度總覽錢包累計收益率',
  100000111:'您已领先 <em class="normal bold" style="color: #2AFF0A;">{percentage}</em>的用户',
  100000112:'在過去的一年裡 ,擁有過銘文帶來的 <em class="normal bold" style="color: #FFF;">FOMO</em>, 也享受過 <em class="normal bold" style="color: #FFF;">meme 暴漲</em> 的喜悅。現在，讓我們一起走進您的記憶',
  100000113:'王牌交易員',
  100000114:'2024年度累計交易(次）',
  100000115:'累計交易金額($)',
  100000116:'你已超越了 <em class="normal bold" style="color: #FFC72B;">{percentage}%</em> 的用戶',
  100000117:'這不僅是數字的累積，更是您眼光與智慧的勳章',
  100000118:'每一次交易，都是邁向Web3.0的動力',
  100000119:'潛力新星',
  100000120:'Bitcoin在2024年最大跌幅達到<em class="normal">34%</em>，市場調整為常態，您的投資表現只是階段性的結果，未來仍充滿可能！',
  100000121:'穩健投資者',
  100000122:'每一次的觀察和等待，都是為了迎接更精準的時機，期待2025年可以見到屬於您的投資與盈利奇蹟',
  100000123:'您在2024年交易次數最多的代幣',
  100000124:'念念不忘，必有迴響',
  100000125:'專注與付出，已在交易成果中熠熠生輝',
  100000126:'2024年Bitcoin在SuperEx的漲跌幅',
  100000127:'2024年你的Bitcoin涨跌幅',
  100000128:'恭喜你的資產實現增長！來年再接再厲',
  100000129:'2024年你還未持有過Bitcoin',
  100000130:'卓越投資者',
  100000131:'穩健投資者',
  100000132:'學習型投資者',
  100000133:'你的現貨主板區交易數據',
  100000134:'累積收益($)',
  100000135:'年化收益率(%)',
  100000136:'收益領先(%)',
  100000137:'你的合約交易數據',
  100000138:'展現了您在投資策略上的智慧，感謝您選擇與我們同行!',
  100000139:'揚帆·再起航',
  100000140:'你不僅跟上了潮流，還是潮流的先鋒！你在自由區上幣 <em class="normal bold" style="color: #FFF;">{num1}</em> 次,交易了 <em class="normal bold" style="color: #FFF;">{num2}</em> 次。喜歡創新產品的你，才是真正的冒險家！',
  100000141:'超級社交達人',
  100000142:'感謝您為我們帶來了 <em class="normal bold" style="color: #FFF;">{num}</em> 個新面孔，平台因為你的推薦而蓬勃發展，通往Web3.0的道路上，期望有更多志同道合的朋友',
  100000143:'社交潛力新星',
  100000144:'有 <em class="normal bold" style="color: #FFF;">{num}</em> 名SuperEx用戶,通過邀請好友賺取高達40%的交易佣金，2024的年你錯過了，沒關係。2025年請抓住機會。',
  100000145:'分享你的年度精彩時刻！分享到你的社區，鼓勵更多人加入我們，一起解鎖專屬豐厚獎勵，一起探索加密世界！',
  100000146:'邀請一名好友即可獲得價值10USDT獎勵 !',
  100000147:'分享報告',
  100000148:'再次查看',
  100000149:'2024年，你在Superex被稱呼為',
  100000150:'你已超越平台用戶:',
  100000151:'現貨主板區年化收益率:',
  100000152:'合約年化收益率',
  100000153:'這一年，我是投資傳奇！',
  100000154:'邀請碼: {InviteCode}',
  100000155:'SuperEx.com - web3.0 加密貨幣交易所',
  100000156:'穩中求勝，實力盡顯！',
  100000157:'這一年積累經驗，新一年更精彩！',
  100000158:'你知道嗎?',
  100000159:'SuperEx的現貨自由區是全球最熱門、最有潛力的Meme幣交易平台',
  100000160:'2024, SuperEx新增 <em class="normal bold" style="color: #FFF;">{num}</em> 用戶，作為全新家人',
  100000161:'屬於你的2024回顧和2025千倍收益之旅即將起航。',
  100000162:'這是一份 SuperEx 資深家人寄來的家書, 裡面記錄了他們 2024 年的喜訊。',
  100000163:'@to***成功以1USDT購買1枚BTC，收益率高達 <em class="normal bold" style="color: #FFF;font-size:0.7rem">9,958,800%</em>。',
  100000164:'@1o***用1USDT獲得了1枚ETH,收益率高達 <em class="normal bold" style="color: #FFF;font-size:0.7rem">487,000%</em>。',
  100000165:'@we***用1USDT獲得1台iphone15,收益率高達 <em class="normal bold" style="color: #FFF;font-size:0.7rem">92,800%</em>。',
  100000166:'還有更多精彩...',
  100000167:'小資金、大回報、不斷升級的玩法讓每一次的參與都充滿驚喜！',
  100000168:'現貨、合約、理財...',
  100000169:'家書很長我們接著往下看',
  100000170:'累計首次發行代幣 <span class="inline-block relative bold" style="color: #FFFFFF;font-size:1rem">150+</span> SuperEx將繼續致力於為用戶創造更多的機會。',
  100000171:'年度錢包總覽帳戶累計盈虧率',
  100000172:'錢包總覽帳戶年度盈虧金額 <em class="normal bold {classNum}">{num}</em>',
  100000173:'您已經領先了 <em class="normal bold" style="color: #FFF;font-size:1rem">{percentage}%</em> 的用戶，您在投資策略上的智慧，讓人驚嘆',
  100000174:'2025-SuperEx',
  100000175:'財富之路',
  100000176:'等你推开',
  100000177:'嗨！我是SuperEx的新朋友。',
  100000178:'加入SuperEx,探索無窮可能,註冊即享新手福利。',
  100000179:'用戶@vb***參與現貨主板區交易$ATOM累積收益率近 <em class="normal bold" style="color: #FFF;font-size:0.7rem">10,400%</em>。',
  100000180:'用戶@xi***參與現貨主板區交易$PIPE累計收益率近 <em class="normal bold" style="color: #FFF;font-size:0.7rem">7,400%</em>。',
  100000181:'用戶@09***參與現貨主板區交易$ATH累計收益率近 <em class="normal bold" style="color: #FFF;font-size:0.7rem">3,500%</em>。',
  100000182:'我們期待見證您在WEB3世界的交易所完成首筆交易，開啟精彩篇章！',
  100000183:'1USD、Super Start、1000+現貨、150X槓桿、1000X銘文...',
  100000184:'多種高收益板塊等您體驗！',
  100000185:'漲跌有時，信念長存',
  100000186:'穿越波動，見證價值',
  100000187:'您的2024年度報告尚未生成。歡迎開啟新一年的交易旅程，累積更多互動，屆時即可解鎖下一年度的專屬總結！',
  100000188:'2024加密貨幣年度故事等你回顧！與SuperEx一起重溫2024的高光時刻，快來分享你的專屬瞬間吧！ ',
  100000189:'2024加密貨幣年度故事等你回顧！!',
  100000190: '開啟SuperEx APP查看「年度報告」',
  100000191: '{year}年{month}月{day}日（UTC） ',
  100000192: '購買用戶',
  100000193: '訂單碼',
  100000194: '我',
  100000195: '參與者列表',
  100000196: '數字貨幣商品已發放。實物商品還請您聯繫客服領取',
  100000197: '購買成功',
  100000198: '{name}成功獲得',
  100000199: '立刻搶',
  100000200: '加載到底部了',
  100000201: '恭喜{name}獲得{shop}！',
  100000202: '用戶{name}參與{shop}成功！'

}
export default zhHK


// WEBPACK FOOTER //
// ./src/i18n/langs/languageAllen/zh-HK.js